export const EXPORT_MEMBERS_VALIDATION_RULES = {
  authorizationCode: {
    isRequiredTrim: {
      value: true,
    },
    minLength: {
      value: 4,
    },
  },
  clientId: {
    isRequiredTrim: {
      value: true,
    },
  },
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  fileFormat: {
    isRequiredTrim: {
      value: true,
    },
  },
  languageCode: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exportMembers/exportMembersValidationRules.js